import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  Button,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as orderActions from './actions'
import * as common from '../../lib/common'
import ButtonExt from "../controls/ButtonExt"
import { BtnPermissions } from '../../lib/BtnPermissions'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class ProcessOrderCheckQR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      donHangId: '',
      orderInfor: {},
      InputCode: '',
      ActiveRow: '',
      isShowQRPopup: false,
      OrderQRDetail: [],
      startBarcodePosition: 1,
      startBarcodeCharacter: '',
      lengthQRCode: 10,
      searchQRcode: '',
      listQRFilter: [],
      typingBarcodeTimeout: 0,
    };
    this.handleInputCodeChange = this.handleInputCodeChange.bind(this);
  }
  createNotification = (type, message, title) => {
    const timeOut = 3000
    const callback = null
    const priority = true
    switch (type) {
      case 'info':
        NotificationManager.info(message, title, timeOut, callback, priority);
        break;
      case 'success':
        NotificationManager.success(message, title, timeOut, callback, priority);
        break;
      case 'warning':
        NotificationManager.warning(message, title, timeOut, callback, priority);
        break;
      case 'error':
        NotificationManager.error(message, title, timeOut, callback, priority);
        break;
    }
  };
  // in phiếu xuất
  printOrderData = () => {
    const formData = {
      order_id: this.state.donHangId
    }
    this.props.loadOrderExport(formData);
  }
  // excel phiếu xuất
  exportXls = (orderInfor) => {
    const formData = {
      orderId: orderInfor.order_id,
    }
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "donhang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("Ten file", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    this.props.loadOrderExcel(formData, dialogSaveFile)
  }
  resetInputCode = () => {
    this.InputCode.value = ""
    this.InputCode.focus();
  }
  confirmOrderClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn xác nhận phiếu xuất <b className="text-danger">{this.state.orderInfor.MaXuatKho}</b> không?</p>
            <button className="text-danger" onClick={() => {
              this.props.processOrderConfirm(this.state.orderInfor, (data) => {
                this.createNotification('success', "Phiếu xuất đã được xác nhận thành công", "Thông báo")
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });

  }
  printClick = (orderInfor) => {
    this.setState({ donHangId: orderInfor.order_id }, () => {
      this.printOrderData();
    })
  }
  openDetailQRClick = (item) => {
    if (item) {
      this.setState({ OrderQRDetail: item, isShowQRPopup: true, listQRFilter: item.arrayQR, searchQRcode: '' })
    }
  }
  closeDetailQRClick = () => {
    this.setState({ OrderQRDetail: [], isShowQRPopup: false })
  }
  removeQRClick = (barcode, qrcode) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xoá qr code <b className="text-danger">{qrcode}</b> không?</p>
            <button className="text-danger" onClick={() => {
              let { orderInfor, listQRFilter } = this.state
              const objIndex = orderInfor.items.findIndex((qr => qr.BarCode.includes(barcode)));
              if (objIndex > -1) {
                orderInfor.items[objIndex].arrayQR.splice(orderInfor.items[objIndex].arrayQR.indexOf(qrcode), 1)
                orderInfor.items[objIndex].SoLuongQR = orderInfor.items[objIndex].arrayQR.length
                // listQRFilter.splice(listQRFilter.indexOf(qrcode), 1)
                this.createNotification('success', qrcode + " đã được xóa ra khỏi danh sách", "Thông báo")
                this.setState({ orderInfor, searchQRcode: '' }, () => {
                  this.UpdateSoLuongQR()
                  this.InputQR.focus()
                })
              }
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  UpdateSoLuongQR = () => {
    this.setState({ SoLuongQR: this.sumSoLuongQR() })
  }
  // keyPress = (e, input) => {
  //   if (e.keyCode == 13) {
  //     if (input == "InputCode")
  //       this.CheckInputCode()
  //   }
  // }
  SetActiveRow = (item) => {
    if ((item.BarCode || '').length > 0) {
      this.setState({ ActiveRow: item.BarCode || '' })
    }
  }
  GetQRCodeFromText = (text) => {
    var result = text
    if (text.length > 0) {
      if (text.length >= this.state.startBarcodePosition) {
        result = text.substr(this.state.startBarcodePosition, this.state.lengthQRCode)
      }
    }
    console.log("qrcode = " + result)
    return result;
  }
  CheckInputCode = () => {
    const inputCode = this.state.InputCode
    let { orderInfor } = this.state
    if (inputCode.length == 0) {
      this.createNotification('error', "Hãy nhập mã vạch hoặc chọn dòng muốn kiểm tra", "Thông báo")
      this.resetInputCode()
      return;
    }
    if (inputCode.length > 0) {
      if (inputCode.includes("http") && inputCode.length >= this.state.startBarcodePosition) {//kiểm tra qrcode 
        if (this.state.ActiveRow.length == 0) {
          this.createNotification('error', "Hãy chọn sản phẩm muốn nhập QRCode", "Thông báo")
          this.resetInputCode()
          return;
        }
        var qrCode = this.GetQRCodeFromText(inputCode)
        const checkQR = qrCode.substring(0, this.state.startBarcodeCharacter.length).toLowerCase()
        console.log("checkQR",checkQR)
        if (checkQR == this.state.startBarcodeCharacter.toLowerCase()) {
          const objIndex = orderInfor.items.findIndex((qr => qr.BarCode.includes(this.state.ActiveRow))); // tìm đến dòng active
          if (objIndex > -1) {
            if (orderInfor.items[objIndex].SoLuongQR == orderInfor.items[objIndex].SoLuong) {
              this.createNotification('warning', "Số lượng đã đủ, hãy chọn sản phẩm khác", "Thông báo")
              this.resetInputCode()
              return;
            }
            //kiểm tra xem qr đã được add chưa
            let indexCheck = orderInfor.items.findIndex((qr => qr.arrayQR.includes(qrCode)))
            if (indexCheck > -1) {
              let itemCheck = orderInfor.items[indexCheck]
              this.createNotification('warning', "QRCode đã được sử dụng tại: " + itemCheck.Sku + '/' + itemCheck.TenHang, "Thông báo")
              this.resetInputCode()
              return;
            }
            orderInfor.items[objIndex].arrayQR.push(qrCode)
            orderInfor.items[objIndex].SoLuongQR = orderInfor.items[objIndex].arrayQR.length
            this.createNotification('info', "Đã thêm " + qrCode + " thành công", "Thông báo")
            this.setState({ orderInfor, InputCode: '' }, () => {
              this.resetInputCode()
              this.UpdateSoLuongQR()
            })
          } else {
            this.createNotification('error', "Không tìm thấy sản phẩm tương ứng", "Thông báo")
            this.resetInputCode()
            return;
          }
        } else {
          this.createNotification('error', "Sai định dạng QRCode, hãy kiểm tra lại", "Thông báo")
          this.resetInputCode()
          return;
        }

      } else { //Barcode
        const objIndex = orderInfor.items.findIndex((qr => qr.BarCode == inputCode));
        let { ActiveRow } = this.state
        if (objIndex > -1) {
          ActiveRow = inputCode
          this.setState({ ActiveRow }, () => {
            this.resetInputCode()
          })
        } else {
          this.createNotification('error', "Không tìm thấy sản phẩm tương ứng", "Thông báo")
          this.resetInputCode()
        }
      }
    }
  }
  return2List = () => {
    this.props.history.push('/process-order-checked');
  }
  getOrderDetail = () => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { id } = params;
      this.setState({ donHangId: id }, () => {
        this.fetchData(id)
      })
    }
  }
  sumSoLuongQR = () => {
    return common.sum(this.state.orderInfor.items || [], "SoLuongQR")
  }
  fetchData = (orderId) => {
    const payload = {
      xuatKhoId: orderId || this.props.orderId
    }
    this.props.getOrderDetails(payload, (data) => {
      if (data.xuatKho && data.items && data.items.length > 0) {
        var arrItems = data.items.map(item => (
          {
            id: item.Id || '',
            Sku: item.Sku || '',
            TenHang: item.TenHang || '',
            Dvt: item.Dvt || '',
            SoLuong: item.SoLuong || 0,
            SoLuongQR: item.arrayQR.length || 0,
            BarCode: item.BarCode || '',
            arrayQR: item.arrayQR || []
          }
        ));
        var orderInfor = {
          xuatKhoId: data.xuatKho.Id || 0,
          MaXuatKho: data.xuatKho.MaXuatKho || '',
          TrangThai: data.xuatKho.TrangThai || 0,
          TenNhanVien: data.xuatKho.TenNhanVien || '',
          TenNguoiTao: data.xuatKho.TenNguoiTao || '',
          NgayTao: data.xuatKho.NgayTao || null,
          xuatThieu: data.xuatKho.XuatThieu,
          ghiChu: data.xuatKho.GhiChuXuatThieu || '',
          items: arrItems || []
        }
        this.setState({
          startBarcodePosition: data.startBarcodePosition || 0,
          startBarcodeCharacter: data.startBarcodeCharacter || '',
          orderInfor: orderInfor,
          lengthQRCode: data.lengthQRCode
        }, () => {
          this.setState({ SoLuongQR: this.sumSoLuongQR() })
          this.InputCode.focus();
        })
      }
    })
  }
  itemXuatThieuChecked = ({ target }) => {
    let { orderInfor } = this.state
    orderInfor.xuatThieu = target.checked
    console.log("target.checked",target.checked)
    this.setState({ orderInfor })
  }
  handleNoteCreated = ({ target }) => {
    let { orderInfor } = this.state
    orderInfor.ghiChu = target.value
    this.setState({ orderInfor })
  }

  handleBarcodeSearch = (e) => {
    let { searchQRcode, OrderQRDetail, listQRFilter } = this.state
    searchQRcode = this.GetQRCodeFromText(e.target.value)
    this.setState({ searchQRcode }, () => {
      if (searchQRcode.length > 0) {
        listQRFilter = OrderQRDetail.arrayQR.filter(item => item == searchQRcode)
      } else {
        listQRFilter = OrderQRDetail.arrayQR
      }
      if (listQRFilter.length > 0) {
        this.InputQR.focus();
      }
      this.setState({ listQRFilter })
    })
  }
  handleInputCodeChange = (e) => {
    const self = this;
    let { InputCode } = this.state
    InputCode = e.target.value
    if (self.state.typingBarcodeTimeout) {
      clearTimeout(self.state.typingBarcodeTimeout);
    }

    self.setState({
      typing: false,
      typingBarcodeTimeout: setTimeout(function () {
        self.setInputCode(InputCode);
      }, 200)
    });
  }
  setInputCode = (currentInput) => {
    this.setState({
      InputCode: currentInput
    });
    this.CheckInputCode()
  }
  componentDidMount() {
    this.getOrderDetail();
  }

  componentWillUnmount() {
    // reset callback func
    this.props.setCallbackFunc(() => { })
  }
  render() {
    const sumQuantity = () => {
      const items = this.state.orderInfor.items || [];
      return common.sum(items, "SoLuong").toLocaleString()
    }
    const getItems = e => {
      const items = this.state.orderInfor.items || [];
      return items.map((item, idx) => {
        return (
          <tr onClick={() => this.SetActiveRow(item)} key={idx} className={(this.state.ActiveRow === item.BarCode && item.BarCode != '') ? "qr-actived-row" : ""}>
            <td scope="col" className="text-center">
              {idx + 1}
            </td>
            <td scope="col" className="text-left">
              {`${item.Sku}/ ${item.TenHang}`}
            </td>
            <td scope="col" className="text-left">
              {item.BarCode}
            </td>
            <td scope="col" className="text-left">
              {item.Dvt}
            </td>
            <td scope="col" className="text-right">
              {item.SoLuong.toLocaleString()}
            </td>
            <td scope="col" className="text-right">
              {item.arrayQR.length.toLocaleString()}
            </td>
            <td scope="col" className="text-center">
              {item.arrayQR.length > 0 ? <Button size="sm" color="primary" onClick={() => this.openDetailQRClick(item)}>
                <i className="fa fa-qrcode"></i> Chi tiết
              </Button> : '-'
              }
            </td>
          </tr>
        )
      });
    }
    const {
      processOrderCheckQR: {
        requesting,
        errors,
        messages,
      }
    } = this.props
    const { orderInfor, listQRFilter } = this.state
    const { handleInputCodeChange } = this
    return (
      <div className="animated fadeIn order">
        <BlockUi tag="div" blocking={requesting}>
          <div className="col-sm-12 pull-left order-view">
            <Card>
              <CardBody className="p-1">
                <div className="col-sm-12">
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Mã xuất kho: <b>{orderInfor.MaXuatKho || ''}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Trạng thái: {orderInfor.TrangThai == 1 ? <span className="text-success font-weight-bold">Đã xác nhận</span> : <span className="text-danger font-weight-bold">Chưa xác nhận</span>}</span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Nhân viên: <b>{orderInfor.TenNhanVien || ''}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Ngày lập: <b>{orderInfor.NgayTao != '' ? orderInfor.TenNguoiTao + " - " + common.formatDateTime(orderInfor.NgayTao, "HH:mm DD/MM/YYYY") : ''}</b></span>
                  </div>
                  <div className="col-sm-12 mb-2 pull-left">
                    <span className="text-danger font-weight-bold">Xuất thiếu: <input type="checkbox" defaultChecked={orderInfor.xuatThieu} onChange={e => this.itemXuatThieuChecked(e)} /></span>
                  </div>
                  <div className="col-sm-12 mb-2 pull-left">
                    <Input type="textarea" maxLength={250} name="ghiChu" placeholder="Ghi chú" value={orderInfor.ghiChu || ''} onChange={e => this.handleNoteCreated(e)} />
                    <div className="clearfix"></div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div>
                  <div className="col-sm-12">
                    <div role="group">
                      <Button className="btn btn-secondary mr-1 mb-1" onClick={() => this.return2List()}>
                        <i className="fa fa-list"></i> Danh sách
                        </Button>
                      <ButtonExt size="md" btnClass="btn btn-info mr-1" btnClick={() => this.confirmOrderClick()}
                        iconClass="fa-check" displayText="Xác nhận"
                        permission={BtnPermissions.DonXuatKho.CONFIRM_ORDER} />
                    </div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
                <div>
                  <div className="col-sm-12">
                    {!!errors.length && (
                      <Errors message="Failure to signup due to:" errors={errors} />
                    )}
                    {!!messages.length && (
                      <Messages messages={messages} />
                    )}
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <Table responsive className="table-outline table-sm mb-0">
                    <thead className="thead-default">
                      <tr>
                        <th scope="col" width="50" className="text-center table-border-right">#</th>
                        <th scope="col" className="text-left">
                          Tên thuốc
                        </th>
                        <th scope="col" width="120" className="text-left">
                          Mã vạch
                        </th>
                        <th scope="col" width="100" className="text-left">
                          ĐVT
                        </th>
                        <th scope="col" width="120" className="text-right">
                          Số lượng bán
                        </th>
                        <th scope="col" width="120" className="text-right">
                          Số lượng QR
                        </th>
                        <th scope="col" width="120" className="text-center">
                          Danh sách QR
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="7">
                          <input type="text" name="InputCode" ref={(input) => { this.InputCode = input; }} className="form-control" style={{ background: "#96d3ec" }}
                            placeholder="Nhập Barcode, QRCode để thực hiện việc kiểm hàng..." /*onKeyDown={e => this.keyPress(e, "InputCode")}*/ onChange={handleInputCodeChange} />
                        </td>
                        {/* <td className="text-center">
                          <Button size="sm" color="success" onClick={() => this.CheckInputCode()}>
                            <i className="fa fa-download"></i> Thêm
                          </Button>
                        </td> */}
                      </tr>
                      {getItems()}
                    </tbody>
                    <tfoot className="thead-default">
                      <tr>
                        <td colSpan="2" scope="col" className="text-left">
                          <span className="text-primary font-weight-bold">Tổng cộng: </span>
                        </td>
                        <td colSpan="3" scope="col" className="text-right font-weight-bold">
                          {sumQuantity()}
                        </td>
                        <td colSpan="1" scope="col" className="text-right font-weight-bold">
                          {(this.state.SoLuongQR || 0).toLocaleString()}
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="clearfix"></div>
        </BlockUi>
        <NotificationContainer />
        <Modal isOpen={this.state.isShowQRPopup} className="modal-lg">
          <ModalHeader style={{ padding: '0.5rem' }}>
            DANH SÁCH QR CODE : <b>{this.state.OrderQRDetail.TenHang || ''}</b>
          </ModalHeader>
          <ModalBody className="pt-1">
            <BlockUi tag="div" blocking={requesting} className="list-qr">
              <div className="mr-2 mb-2">
                <input type="text" name="InputQR" ref={(input) => { this.InputQR = input; }} className="form-control" style={{ background: "#96d3ec" }}
                  placeholder="Tìm kiếm QR code..." value={this.state.searchQRcode} onChange={this.handleBarcodeSearch.bind(this)} />
              </div>
              <div className="mt2 list-qr-item">
                {listQRFilter && !!listQRFilter.length && (
                  listQRFilter.map((res, idx) => (
                    <span key={idx + 1} className="tag is-success mr-2 mb-2"> {res}
                      <button className="delete is-small" onClick={() => this.removeQRClick(this.state.OrderQRDetail.BarCode, res)}></button>
                    </span>
                  ))
                )}
              </div>
            </BlockUi>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.closeDetailQRClick()}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  processOrderCheckQR: state.processOrderCheckQR
})

const connected = connect(mapStateToProps,
  {
    setIsLoading: orderActions.setIsLoading,
    getOrderDetails: orderActions.getOrderDetails,
    setCallbackFunc: orderActions.setCallbackFunc,
    processOrderConfirm: orderActions.processOrderConfirm
  })(ProcessOrderCheckQR)

const formed = reduxForm({
  form: 'processOrderCheckQR',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/ProcessOrderCheckQR.js